import { useEffect, useState } from "react";
import { API } from "../data/siteData";

export default function useRenderingImages(renderings) {
  const [imageUrls, setImageUrls] = useState({});
  const [state, setState] = useState(renderings.length ? "loading" : "ready");

  useEffect(() => {
    let active = true;
    const objectUrls = [];

    async function loadImages() {
      if (!renderings.length) {
        setImageUrls({});
        setState("ready");
        return;
      }
      setState("loading");
      const loadedImages = await Promise.all(
        renderings.map(async (rendering) => {
          const response = await fetch(`${API}/investor/renderings/${rendering.rendering_id}/image`, {
            credentials: "include",
          });
          if (!response.ok) return [rendering.rendering_id, ""];
          const objectUrl = URL.createObjectURL(await response.blob());
          objectUrls.push(objectUrl);
          return [rendering.rendering_id, objectUrl];
        }),
      );
      if (!active) return;
      setImageUrls(Object.fromEntries(loadedImages));
      setState("ready");
    }

    loadImages().catch(() => {
      if (active) setState("error");
    });

    return () => {
      active = false;
      objectUrls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [renderings]);

  return { imageUrls, state };
}